import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table table-hover align-middle" }
const _hoisted_2 = { class: "pb-2 border-dark border-bottom" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasePlaceholderTable = _resolveComponent("BasePlaceholderTable")!
  const _component_PimProductsOverviewTableItem = _resolveComponent("PimProductsOverviewTableItem")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", null, [
        _hoisted_3,
        (_ctx.AbilityContext.isAuthorizedForFeature('PIM_PRODUCT_CATEGORY'))
          ? (_openBlock(), _createElementBlock("th", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isAllProductsSelectedForCategorization) = $event)),
                  type: "checkbox",
                  name: "is_all_products_selected_for_categorization"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.isAllProductsSelectedForCategorization]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_6,
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('cnkCode')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1),
        (_ctx.isCategoryExpected)
          ? (_openBlock(), _createElementBlock("th", _hoisted_7, _toDisplayString(_ctx.$t('category')), 1))
          : _createCommentVNode("", true),
        (_ctx.isCategoryExpected)
          ? (_openBlock(), _createElementBlock("th", _hoisted_8, _toDisplayString(_ctx.$t('internal')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_ctx.ui.isNotReady())
        ? (_openBlock(), _createBlock(_component_BasePlaceholderTable, {
            key: 0,
            "n-cols": _ctx.AbilityContext.isAuthorizedForFeature('PIM_PRODUCT_CATEGORY') ? 7 : 6
          }, null, 8, ["n-cols"]))
        : (_ctx.ui.isReady() && !_ctx.hasProducts)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
              _createElementVNode("td", {
                colspan: _ctx.AbilityContext.isAuthorizedForFeature('PIM_PRODUCT_CATEGORY') ? 7 : 6,
                class: "fw-bold small text-uppercase text-muted"
              }, _toDisplayString(_ctx.$t('noResults')), 9, _hoisted_10)
            ]))
          : (_ctx.ui.isReady() && _ctx.hasProducts)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.productsOverview.results, (product) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: product.id,
                  class: "position-relative"
                }, [
                  _createVNode(_component_PimProductsOverviewTableItem, {
                    product: product,
                    "is-category-expected": _ctx.isCategoryExpected,
                    onDeletedProduct: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('deletedProduct'))),
                    onSelectedDpCat: _ctx.onSelectedDpCat,
                    onSelectedIntCat: _ctx.onSelectedIntCat,
                    onExceptions: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('exceptions'))),
                    onOpenOffCanvasProductDetail: ($event: any) => (_ctx.$emit('openOffCanvasProductDetail', product))
                  }, null, 8, ["product", "is-category-expected", "onSelectedDpCat", "onSelectedIntCat", "onOpenOffCanvasProductDetail"])
                ]))
              }), 128))
            : _createCommentVNode("", true)
    ])
  ]))
}